"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../icons");

var _ = require("../..");

var _hooks = require("../../../hooks");

var styles = _interopRequireWildcard(require("./modal.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Modal = _ref => {
  let {
    header,
    footer,
    content,
    onClose,
    children,
    size,
    extraClassName,
    showCloseButton,
    closeOnBackdropClick,
    closeOnEscapeKeyPress
  } = _ref;
  const isEscapeKeyPressed = (0, _hooks.useKeyPress)("Escape");
  const containerRef = (0, _react.useRef)(null);
  const scrollerRef = (0, _react.useRef)(null);
  const wrapperRef = (0, _react.useRef)(null);
  const isMounted = (0, _hooks.useIsMounted)();
  const closeHandler = (0, _react.useCallback)(() => {
    if (typeof onClose !== "function") {
      return;
    }

    onClose();
  }, [onClose]);
  const clickHandler = (0, _react.useCallback)(event => {
    if (event.target !== containerRef.current && event.target !== scrollerRef.current && event.target !== wrapperRef.current) {
      return;
    }

    if (!closeOnBackdropClick) {
      return;
    }

    closeHandler();
  }, [wrapperRef, scrollerRef, closeOnBackdropClick, closeHandler]);
  const wrapperClassName = (0, _react.useMemo)(() => [styles.wrapper, styles[size]].join(" "), [size]);
  const contentClassName = (0, _react.useMemo)(() => [styles.content, extraClassName].join(" "), [extraClassName]);
  const closeButton = (0, _react.useMemo)(() => showCloseButton && /*#__PURE__*/_react.default.createElement("button", {
    className: styles.closeButton,
    onClick: closeHandler
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseIcon, {
    className: styles.svg
  })), [showCloseButton, closeHandler]);
  (0, _react.useEffect)(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (!closeOnEscapeKeyPress) {
      return;
    }

    if (!isEscapeKeyPressed) {
      return;
    }

    closeHandler();
  }, [isEscapeKeyPressed, closeOnEscapeKeyPress, closeHandler]);
  return isMounted ? /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    ref: wrapperRef,
    onClick: clickHandler,
    className: wrapperClassName
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: scrollerRef,
    className: styles.scroller
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef,
    className: styles.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: contentClassName
  }, /*#__PURE__*/_react.default.createElement(_.Card, {
    header: header && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.header
    }, header, closeButton),
    footer: footer && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.footer
    }, footer)
  }, !header && /*#__PURE__*/_react.default.createElement("div", {
    className: styles.close
  }, closeButton), children))))), document.body) : null;
};

exports.Modal = Modal;
Modal.defaultProps = {
  size: "md",
  extraClassName: "",
  showCloseButton: true,
  closeOnBackdropClick: true,
  closeOnEscapeKeyPress: true
};
Modal.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  header: _propTypes.default.node,
  footer: _propTypes.default.node,
  extraClassName: _propTypes.default.string,
  showCloseButton: _propTypes.default.bool,
  closeOnBackdropClick: _propTypes.default.bool,
  closeOnEscapeKeyPress: _propTypes.default.bool,
  size: _propTypes.default.oneOf(["sm", "md", "lg", "auto"])
};